import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class EndpointPortalIcon extends BaseIcon {
  getChildren = () => [ <g >
    <rect fill={'white'} x="10" y="8" width="5" height="4"/>
    <path
      fill={ this.getColor() }
      d="M20.9,10.89v0a7.24,7.24,0,0,0-1.25-5.18,6.45,6.45,0,0,0-3.18-2.36,6.68,6.68,0,0,0-8.6,4.47A5.92,5.92,0,0,0,1.27,10,6,6,0,0,0,.12,12.51,6.19,6.19,0,0,0,6.05,20H19.49A4.61,4.61,0,0,0,24,15.29,4.68,4.68,0,0,0,20.9,10.89ZM10,10.35A2.35,2.35,0,0,1,12.35,8h.3A2.35,2.35,0,0,1,15,10.35V12H14V10.35A1.34,1.34,0,0,0,12.65,9h-.3A1.34,1.34,0,0,0,11,10.35V12H10ZM16,18H9V13h7Z"/>
  </g> ]
  getViewBox = () => '0 0 24 24'
}
